import { axiosInstance } from './axiosInstance';

export const editUserDetails = (postData) => axiosInstance.put(`/user/userDetailChange`, postData);

export const editAdminDetails = (postData) => axiosInstance.put(`/admin/admin`, postData);

export const upsertProfileImage = (fileName, formData) => axiosInstance.post(`/user/uploadProfileImage?fileName=${fileName}`, formData);
